 
import ajax from './request'
 
  
export const login=(data)=> { 
    return ajax({
        url: '/api/login',
        method: 'post',
        data,
    })
}

  
export const getUserInfo=(data)=> { 
    return ajax({
        url: '/api/login/getInfo',
        method: 'get',
        params:data,
    })
}

//观看模型(每次打开模型都调用此接口，增加阅读量)
export const modelRead=(data)=> { 
    return ajax({
        url: `/api/model/read/${data.userId}/${data.modelId}`,
        method: 'get',
        params:data,
    })
}

//取消收藏
export const cancelCollection=(data)=> { 
    return ajax({
        url: `/api/model/cancelCollection`,
        method: 'post',
        data,
    })
}
 //收藏
//  /${data.userId}/${data.modelId}
export const collection=(data)=> { 
    return ajax({
        url: `/api/model/collection`,
        method: 'post',
        data,
    })
}
//获取模型列表
export const getModelList=(data)=> { 
    return ajax({
        url: `/api/model/list`,
        method: 'get',
        params:data,
    })
}
 
//获取模型列表
export const getBaiduToken=(data)=> { 
    return ajax({
        url: 'api/model/getToken',
        method: 'get',
        params:data,
    })
}
  